var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CostAllocationFormComponent',_vm._g(_vm._b({model:{value:(_vm.myCostAllocationMock),callback:function ($$v) {_vm.myCostAllocationMock=$$v},expression:"myCostAllocationMock"}},'CostAllocationFormComponent',_vm.costAllocationFormComponentProps,false),( _obj = {}, _obj[_vm.EVENTS.updateForm] = function (value) { _vm.form = value }, _obj )))],1)}
var staticRenderFns = []

export { render, staticRenderFns }